import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ce1a5cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["href"];
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" (");
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ _createTextVNode(") ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        cancelBtnTxt: "Done",
        actionBtnTxt: "",
        onOnPopupDone: _ctx.onPopupDone,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createElementVNode("img", {
                src: _ctx.lazyLoadedImg,
                class: "img-thumbnail mb-2 mx-auto",
                style: { "display": "block", "width": "192px", "height": "192px" }
            }, null, 8, _hoisted_1),
            _createElementVNode("p", null, " The following organizations and individuals have contributed, directly or indirectly, to the " + _toDisplayString(_ctx.appName) + " project: ", 1),
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contributorCreditsToShowInOrder, (credit) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: credit.name
                    }, [
                        (credit.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: credit.url,
                                target: "_blank"
                            }, _toDisplayString(credit.name), 9, _hoisted_2))
                            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(credit.name), 1))
                    ]));
                }), 128))
            ]),
            _createElementVNode("p", null, " We also thank the following open-source projects that make " + _toDisplayString(_ctx.appName) + " possible: ", 1),
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareCreditsToShowInOrder, (credit) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: credit.name
                    }, [
                        _createElementVNode("a", {
                            href: credit.url,
                            target: "_blank"
                        }, _toDisplayString(credit.name), 9, _hoisted_4),
                        _hoisted_5,
                        _createElementVNode("a", {
                            href: credit.license.url,
                            target: "_blank"
                        }, _toDisplayString(credit.license.name), 9, _hoisted_6),
                        _hoisted_7
                    ]));
                }), 128))
            ]),
            _createElementVNode("p", null, "This version of " + _toDisplayString(_ctx.appName) + " was compiled on " + _toDisplayString(_ctx.appCompileTime) + ".", 1)
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnPopupDone", "onOnUserArgChanged"]));
}
